<h2 mat-dialog-title>Crop Image</h2>
<mat-dialog-content>
  <p class="cropper-dialog__hint">
    Drag and resize the box to crop your image, then click Finalize.
  </p>
  <div class="cropper-dialog__stage">
    <image-cropper
      [imageFile]="data.file"
      [maintainAspectRatio]="false"
      alignImage="center"
      output="base64"
      format="png"
      (imageCropped)="onImageCropped($event)"></image-cropper>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" class="btn ghost-btn" (click)="cancel()">Cancel</button>
  <button
    type="button"
    class="btn primary-btn"
    [disabled]="!croppedImage"
    (click)="finalize()">
    Finalize
  </button>
</mat-dialog-actions>
